module.exports = __webpack_public_path__ + "img/arrow-transparent.6ccc6e01.svg";